import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgVideo = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 60 60",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	width: "1em",
	height: "1em",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			width: 60,
			height: 60,
			rx: 15,
			fill: "#0166B3"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M24.0274 21.6164V22.6164C24.3831 22.6164 24.712 22.4275 24.8912 22.1203L24.0274 21.6164ZM26.137 18V17C25.7813 17 25.4524 17.1889 25.2732 17.4961L26.137 18ZM33.9726 18L34.8364 17.4961C34.6572 17.1889 34.3283 17 33.9726 17V18ZM36.0822 21.6164L35.2184 22.1203C35.3976 22.4275 35.7265 22.6164 36.0822 22.6164V21.6164ZM19 36.9863V24.6301H17V36.9863H19ZM21.0137 22.6164H24.0274V20.6164H21.0137V22.6164ZM24.8912 22.1203L27.0008 18.5039L25.2732 17.4961L23.1636 21.1126L24.8912 22.1203ZM26.137 19H33.9726V17H26.137V19ZM33.1088 18.5039L35.2184 22.1203L36.946 21.1126L34.8364 17.4961L33.1088 18.5039ZM36.0822 22.6164H39.0959V20.6164H36.0822V22.6164ZM41.1096 24.6301V36.9863H43.1096V24.6301H41.1096ZM41.1096 36.9863C41.1096 38.0984 40.208 39 39.0959 39V41C41.3126 41 43.1096 39.203 43.1096 36.9863H41.1096ZM39.0959 22.6164C40.208 22.6164 41.1096 23.518 41.1096 24.6301H43.1096C43.1096 22.4134 41.3126 20.6164 39.0959 20.6164V22.6164ZM19 24.6301C19 23.518 19.9016 22.6164 21.0137 22.6164V20.6164C18.797 20.6164 17 22.4134 17 24.6301H19ZM21.0137 39C19.9016 39 19 38.0984 19 36.9863H17C17 39.203 18.797 41 21.0137 41V39ZM33.5753 30.0548C33.5753 31.9991 31.9991 33.5753 30.0548 33.5753V35.5753C33.1037 35.5753 35.5753 33.1037 35.5753 30.0548H33.5753ZM30.0548 33.5753C28.1104 33.5753 26.5342 31.9991 26.5342 30.0548H24.5342C24.5342 33.1037 27.0059 35.5753 30.0548 35.5753V33.5753ZM26.5342 30.0548C26.5342 28.1104 28.1104 26.5342 30.0548 26.5342V24.5342C27.0059 24.5342 24.5342 27.0059 24.5342 30.0548H26.5342ZM30.0548 26.5342C31.9991 26.5342 33.5753 28.1104 33.5753 30.0548H35.5753C35.5753 27.0059 33.1037 24.5342 30.0548 24.5342V26.5342ZM39.0959 39H21.0137V41H39.0959V39Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M9 10H21",
			stroke: "white",
			strokeWidth: 1.5,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M9 10L9 22",
			stroke: "white",
			strokeWidth: 1.5,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M51 10L51 22",
			stroke: "white",
			strokeWidth: 1.5,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M51 10L39 10",
			stroke: "white",
			strokeWidth: 1.5,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M9 49L9 37",
			stroke: "white",
			strokeWidth: 1.5,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M9 49L21 49",
			stroke: "white",
			strokeWidth: 1.5,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M51 49L39 49",
			stroke: "white",
			strokeWidth: 1.5,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M51 49L51 37",
			stroke: "white",
			strokeWidth: 1.5,
			strokeLinecap: "round"
		})
	]
});
export default SvgVideo;
